var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeaderHoverChecknft = function SvgIconHeaderHoverChecknft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M16.8 2.4h-12a2.37 2.37 0 0 0-2.4 2.4v12c0 1.35 1.05 2.4 2.4 2.4h6.9c-.6-.825-.9-1.875-.9-3v-.6c-.3 0-.6-.3-.6-.6v-3.6c0-.3.3-.6.6-.6s.6.3.6.6v2.325c.6-1.2 1.725-2.175 3-2.625V6.6c0-.3.3-.6.6-.6s.6.3.6.6v4.275h.6c1.125 0 2.175.3 3 .9V4.8c0-1.35-1.05-2.4-2.4-2.4ZM7.2 15c0 .3-.3.6-.6.6S6 15.3 6 15V9c0-.3.3-.6.6-.6s.6.3.6.6v6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "m22.65 21.75-3.075-3c1.35-1.875.975-4.5-.825-5.85-1.875-1.425-4.5-.975-5.85.825-1.425 1.875-.975 4.5.825 5.85.75.525 1.575.825 2.475.825.975 0 1.8-.3 2.55-.825l3.075 3.075c.225.225.6.225.825 0 .225-.3.225-.675 0-.9ZM16.2 19.2c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3Z"
  })));
};
export default SvgIconHeaderHoverChecknft;